// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:768px){p[data-v-35542b8d]:nth-of-type(2){grid-row-start:3}p[data-v-35542b8d]:nth-of-type(3){grid-row-start:5}p[data-v-35542b8d]:nth-of-type(5),p[data-v-35542b8d]:nth-of-type(7),span[data-v-35542b8d]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
